// src/components/commercial/OnboardingResult.jsx
//
// What happened when an ambassador was created or their welcome e-mail
// re-sent (backend utils/ambassadorWelcome.ts): Keycloak account, ROLE_SALES,
// password link, welcome e-mail - and what to do when a step failed.
import React from 'react';
import { Alert, Box, Typography } from '@mui/material';

const ACCOUNT = {
  created: 'Compte QRProofs créé',
  existing: 'Compte QRProofs existant (même e-mail) réutilisé',
  skipped: 'Compte non géré automatiquement',
  failed: 'Échec de la gestion du compte',
};

export default function OnboardingResult({ result, email }) {
  if (!result) return null;
  const keycloakOff = result.errors?.includes('KEYCLOAK_NOT_CONFIGURED');
  const ok = result.roleGranted && result.welcomeSent;
  const lines = [
    [result.account === 'created' || result.account === 'existing', ACCOUNT[result.account] ?? result.account],
    [result.roleGranted, result.roleGranted ? 'Accès ambassadeur (ROLE_SALES) donné' : 'Accès ambassadeur (ROLE_SALES) non donné'],
    ...(result.passwordEmailSent ? [[true, 'Lien « choisir mon mot de passe » envoyé par Keycloak']] : []),
    [result.welcomeSent, result.welcomeSent ? `E-mail de bienvenue envoyé à ${email}` : 'E-mail de bienvenue non envoyé'],
  ];
  return (
    <Alert severity={ok ? 'success' : 'warning'} sx={{ mb: 2 }}>
      {lines.map(([done, label]) => (
        <Typography key={label} variant="body2">{done ? '✓' : '✕'} {label}</Typography>
      ))}
      {!result.roleGranted && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="body2">
            {keycloakOff
              ? 'La création automatique des accès n’est pas configurée : '
              : 'Keycloak n’a pas répondu : '}
            donnez le rôle <b>ROLE_SALES</b> au compte {email} dans la console Keycloak, ou réessayez avec
            « Renvoyer l’e-mail de bienvenue » sur sa fiche.
          </Typography>
        </Box>
      )}
      {!result.welcomeSent && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          Vérifiez l’adresse, puis réessayez avec « Renvoyer l’e-mail de bienvenue » sur sa fiche.
        </Typography>
      )}
    </Alert>
  );
}
